import React from 'react';
import './index.scss';
// PROCESSING文件处理中,FAILURE文件处理失败，FINISHED完成

const status = {
    PROCESSING: '转码中',
    FAILURE: '转码失败，请重新上传',
    FINISHED: '',
};

export const UnitLi = (props) => {
    return (
        <div className="response-unit-li-box">
            <a href={`/posts/detail/${props.id}`} className="question-img">
                <img
                    src={
                        props.imageUrls && props.imageUrls.length > 0
                            ? props.imageUrls[0]
                            : props.surfacePlot
                    }
                    alt=""
                />
                <span className="iconfont duration-box">
                    <i>&#xe743;</i>
                    {props.playTime}
                </span>
            </a>
            <div className="question-info-box">
                <div className="question-title-tag">
                    <h3>
                        <a href={`/posts/detail/${props.id}`}>
                            {substrTit(props.title)}
                        </a>
                    </h3>
                    <p className="question-tag-box">
                        <span className="browse-tag">
                            <i></i>
                            {props.browseSum}
                        </span>
                        <span className="like-tag">
                            <i></i>
                            {props.favourSum}
                        </span>
                        <span className="answer-tag">
                            <i></i>
                            {props.commentSum}
                        </span>
                        <span className="collect">
                            <i></i>
                            {props.collectSum}
                        </span>
                    </p>
                    <p className="question-date">
                        {props.releaseTime}
                        <span  style={{paddingLeft: '20px'}}>
                        {props.groupName}
                        </span>
                        <span style={{paddingLeft: '20px', color: props.item.auditDescription ? 'red' : 'green'}}>
                        {props.statusName}
                        {props.item.auditDescription ? `:${props.item.auditDescription}` : ''}
                        </span>
                    </p>
                    <p>
                     {status[props.item.transcodeStatus]}
                    </p>
                </div>
                <div className="right-tool">
                    {props.editCall && (
                        <span
                            className="edit-button"
                            onClick={() => props.editCall(props.id)}>
                            修改
                        </span>
                    )}
                    {props.delVideo && (
                        <span
                            className="del-button"
                            onClick={() => props.delVideo(props.id)}>
                            删除
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

function substrTit(title) {
    if (title.length > 113) {
        return title.substr(0, 113) + '...';
    }
    return title;
}
